<template>
    <div class="modal modal-open" id="modal-confirm">
        <div class="modal-overflow">
            <div class="modal-window">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <h3 class="modal-title" v-html="title"></h3>
                        </div>
                    </div>
                    <div class="row jus-c--center">
                        <div class="col-xl-6 col-lg-6">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="onApplyAction"
                                    type="button"
                                    class="btn"
                                >
                                    {{ applyLabel }}
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6" v-if="onSecondaryAction && secondaryLabel">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="onSecondaryAction"
                                    type="button"
                                    class="btn"
                                >
                                    {{ secondaryLabel }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Confirm_Modal",
    props: [
        "title",
        "onApplyAction",
        "onSecondaryAction",
        "applyLabel",
        "secondaryLabel",
    ],
};
</script>
